(function ($) {
	$(document).ready(function () {
		if (typeof $(document).foundation === "function") {
			$(document).foundation();
		}

		document.querySelectorAll(".site-header").forEach((header) => {
			const toggle = header.querySelector(".site-header__toggle");
			const nav = header.querySelector(".site-header__nav");
			const parentItems = nav ? Array.from(nav.querySelectorAll(".menu-item-has-children")) : [];
			const syncScrolledState = () => {
				header.classList.toggle("is-scrolled", window.scrollY > 8);
			};

			if (!toggle || !nav) {
				syncScrolledState();
				window.addEventListener("scroll", syncScrolledState, { passive: true });
				return;
			}

			const closeMenu = () => {
				header.classList.remove("is-menu-open");
				header.setAttribute("data-menu-open", "false");
				toggle.setAttribute("aria-expanded", "false");
				parentItems.forEach((item) => {
					item.classList.remove("is-submenu-open");
					const triggerLink = item.querySelector(":scope > a");
					if (triggerLink) {
						triggerLink.setAttribute("aria-expanded", "false");
					}
				});
			};

			parentItems.forEach((item) => {
				const triggerLink = item.querySelector(":scope > a");
				if (!triggerLink) {
					return;
				}

				triggerLink.setAttribute("aria-expanded", "false");
				triggerLink.setAttribute("data-submenu-toggle", "true");

				triggerLink.addEventListener("click", (event) => {
					if (window.innerWidth > 1100) {
						return;
					}

					event.preventDefault();
					const isOpen = item.classList.contains("is-submenu-open");

					parentItems.forEach((otherItem) => {
						otherItem.classList.remove("is-submenu-open");
						const otherLink = otherItem.querySelector(":scope > a");
						if (otherLink) {
							otherLink.setAttribute("aria-expanded", "false");
						}
					});

					if (!isOpen) {
						item.classList.add("is-submenu-open");
						triggerLink.setAttribute("aria-expanded", "true");
					}
				});
			});

			toggle.addEventListener("click", () => {
				const isOpen = !header.classList.contains("is-menu-open");
				header.classList.toggle("is-menu-open", isOpen);
				header.setAttribute("data-menu-open", isOpen ? "true" : "false");
				toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
			});

			nav.querySelectorAll("a").forEach((link) => {
				link.addEventListener("click", () => {
					if (window.innerWidth <= 1100 && link.getAttribute("data-submenu-toggle") !== "true") {
						closeMenu();
					}
				});
			});

			window.addEventListener("resize", () => {
				if (window.innerWidth > 1100) {
					closeMenu();
				}
			});

			syncScrolledState();
			window.addEventListener("scroll", syncScrolledState, { passive: true });
		});

		if (typeof window.Swiper === "function") {
			const projectsSlider = document.querySelector(".saw-projects-swiper");
			const spaceEventsSlider = document.querySelector(".spaces-single__events-swiper");

			if (projectsSlider) {
				new window.Swiper(projectsSlider, {
					slidesPerView: 1.15,
					spaceBetween: 12,
					grabCursor: true,
					breakpoints: {
						640: {
							slidesPerView: 1.8,
							spaceBetween: 16,
						},
						1024: {
							slidesPerView: 2.5,
							spaceBetween: 16,
						},
						1280: {
							slidesPerView: 3.5,
							spaceBetween: 16,
						},
					},
				});
			}

			if (spaceEventsSlider) {
				new window.Swiper(spaceEventsSlider, {
					slidesPerView: 1.05,
					spaceBetween: 5,
					grabCursor: true,
					breakpoints: {
						640: {
							slidesPerView: 1.55,
							spaceBetween: 5,
						},
						1024: {
							slidesPerView: 2.35,
							spaceBetween: 5,
						},
						1280: {
							slidesPerView: 3.05,
							spaceBetween: 5,
						},
					},
				});
			}
		}

		if (typeof window.GLightbox === "function") {
			window.GLightbox({
				selector: ".spaces-single__gallery-link, .service-single__gallery-link",
				loop: true,
				touchNavigation: true,
				keyboardNavigation: true,
				closeButton: true,
				closeOnOutsideClick: true,
				draggable: true,
				openEffect: "zoom",
				closeEffect: "fade",
			});
		}
	});
})(jQuery);
